import { MinisterialActivityKind, MinistryEventType } from '../../models/person-event.model';

export interface MinisterialActivitySummaryContext {
  actionLabel: string;
  effectiveDate: string;
  expectedEndDate?: string;
  actPlace?: string;
  designationSummary: string;
  expectedEndDateSentence: string;
  actPlaceSentence: string;
  commentSentence: string;
  designationSentence: string;
  items: string;
  remaining: string;
}

export const ministerialActivitySummaryConfig = {
  incompleteMessage: 'Completa los datos obligatorios para poder registrar este evento ministerial.',
  appointmentAssignmentIncomplete:
    'Se va a registrar un encargo o nombramiento con fecha {effectiveDate}. Antes de continuar, selecciona el encargo o nombramiento y el area correspondiente.',
  appointmentAssignment:
    'Se va a registrar {designationSummary} con fecha {effectiveDate}.',
  default:
    'Se va a registrar {actionLabel} con fecha efectiva {effectiveDate}.{expectedEndDateSentence}{actPlaceSentence}{commentSentence}{designationSentence}',
  expectedEndDateSentence: ' La fecha de finalizacion quedara informada como {expectedEndDate}.',
  expectedEndDateMissingSentence: ' Todavia falta informar la fecha de finalizacion.',
  actPlaceSentence: ' El lugar del acto sera {actPlace}.',
  commentSentence: ' Se guardara el comentario cargado.',
  designationSentence: ' {designationSummary}.',
  designationIncomplete: 'Antes de registrar, completa las designaciones o areas requeridas',
  designationList: 'Se incluiran {items}',
  designationListWithRemaining: 'Se incluiran {items} y {remaining} mas',
  activityArticles: {
    Appointment: 'el encargo de',
    Assignment: 'el nombramiento de',
    Ministry: 'el ministerio de',
  } satisfies Record<MinisterialActivityKind, string>,
  actionTemplates: {
    Reassignment:
      'Se mantiene el ministerio actual. La reasignacion solo modifica sus areas de actividad.{designationSentence}',
    NewOfficiant:
      'Se va a registrar la actividad de oficiante para {actPlace} con fecha efectiva {effectiveDate}.{commentSentence}',
  } as Partial<Record<MinistryEventType, string>>,
};

export function applyMinisterialActivitySummaryTemplate(
  template: string,
  context: MinisterialActivitySummaryContext,
): string {
  return template.replace(/\{(\w+)\}/g, (_, key: keyof MinisterialActivitySummaryContext) => context[key] ?? '');
}
